import script from "./AccommodationDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccommodationDetails.vue?vue&type=script&setup=true&lang=ts"

import "./AccommodationDetails.vue?vue&type=style&index=0&id=4e656a7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e656a7e"]])

export default __exports__